// Nivoi organizacione strukture: 0 Uprava, 1-3 postojeće jedinice,
// 4-6 podjedinice (tabela sub_units). Nazive nivoa 1-3 ne diramo;
// podjedinice nose zajednički naziv sa oznakom nivoa.
export const MAX_ORG_LEVEL = 6;
export const SUB_UNIT_LEVELS = [4, 5, 6];

export const levelLabel = (level) => {
  switch (Number(level)) {
    case 0:
      return "Uprava";
    case 4:
    case 5:
    case 6:
      return `Jedinica ${level}. nivoa`;
    default:
      return "Organizaciona jedinica";
  }
};
